<template>
  <footer class="footer-distributed">
    <div class="footer-left">
      <router-link :to="{ path: '/', hash: '#nav' }"
        ><h3>Food<span>Hub</span></h3></router-link
      >

      <p class="footer-links">
        <router-link :to="{ hash: '#nav' }">Home</router-link>
        ·
        <a href="#">Blog</a>
        ·
        <a href="#">Pricing</a>
        ·
        <a href="#">About</a>
        ·
        <a href="#">Faq</a>
        ·
        <a href="#">Contact</a>
      </p>

      <p class="footer-company-name">FoodHub © 2021</p>

      <div class="footer-icons">
        <a href="#"><i class="fa fa-facebook"></i></a>
        <a href="#"><i class="fa fa-twitter"></i></a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer-distributed {
  background: linear-gradient(135deg, #35495e 60%, #41b883);

  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  width: 100%;
  font: bold 16px sans-serif;
  text-align: center;
  padding: 50px 60px 40px;
  overflow: hidden;
}

/* The company logo */

.footer-distributed h3 {
  color: #ffffff;
  margin: 0 0 10px;
}

.footer-distributed h3 span {
  color: yellow;
}

/* Footer links */

.footer-distributed .footer-links {
  color: #ffffff;
  margin: 0 0 10px;
  padding: 0;
}

.footer-distributed .footer-links a {
  display: inline-block;
  line-height: 1.8;
  text-decoration: none;
  color: inherit;
}

.footer-distributed .footer-company-name {
  color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
}

/* Footer social icons */
.fa {
  color: rgb(17, 184, 103);
}
.footer-distributed .footer-icons {
  margin-top: 40px;
}

.footer-distributed .footer-icons a {
  display: inline-block;
  width: 35px;
  height: 35px;
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 2px;

  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 35px;

  margin-right: 3px;
  margin-bottom: 5px;
}

@media (max-width: 1000px) {
  .footer-distributed {
    font: bold 14px sans-serif;
  }

  .footer-distributed .footer-company-name {
    font-size: 12px;
  }

  .footer-distributed form input,
  .footer-distributed form textarea {
    width: 250px;
  }

  .footer-distributed form button {
    padding: 10px 35px;
  }
}

@media (max-width: 800px) {
  .footer-distributed {
    padding: 30px;
  }

  .footer-distributed .footer-left,
  .footer-distributed .footer-right {
    float: none;
    max-width: 300px;
    margin: 0 auto;
  }

  .footer-distributed .footer-left {
    margin-bottom: 40px;
  }

  .footer-distributed form {
    margin-top: 30px;
  }

  .footer-distributed form {
    display: block;
  }

  .footer-distributed form button {
    float: none;
  }
}
</style>
